import React from 'react';
import './Blogs.css';
import { FaMedium, FaExternalLinkAlt } from 'react-icons/fa';
import { blogsData } from '../data/portfolioData';

const Blogs: React.FC = () => {
  return (
    <div className="blogs-page">
      <div className="blogs-header">
        <h1 className="blogs-page-title">Blog</h1>
        <p className="blogs-page-subtitle">Thoughts on AI, design, and what it means to build responsibly</p>
      </div>
      <div className="blogs-grid">
        {blogsData.map((blog, index) => (
          <a
            href={blog.link}
            key={index}
            target="_blank"
            rel="noopener noreferrer"
            className="blog-card"
            style={{ animationDelay: `${index * 0.12}s` }}
          >
            <div className="blog-card-body">
              <h3 className="blog-card-title">{blog.title}</h3>
              <p className="blog-card-desc">{blog.description}</p>
            </div>
            <div className="blog-card-footer">
              <span className="blog-card-platform">
                <FaMedium /> {blog.platform}
              </span>
              <span className="blog-card-read">
                Read Article <FaExternalLinkAlt />
              </span>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
};

export default Blogs;
